<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
    <div class="main" style="border: 1px solid transparent;border-color: #bce8f1;position: relative">
        <div style="color: #31708f;background-color: #d9edf7;border: 1px solid transparent;border-color: #bce8f1;padding: 5px 15px;position: relative">
            <h3 style="font-size:16px;text-shadow: none;font-weight: 400;line-height: 27px;margin:0px;">
                Transaction Details
            </h3>
            <i @click="init()" class="el-icon-refresh"
               style="font-size: 22px;cursor: pointer;position: absolute;right: 15px;top: 9px"></i>
        </div>
        <div style="">
            <table cellspacing="0" cellpadding="0" v-show="tran.hash">
                <tbody>
                <tr>
                    <td width="190">Hash:</td>
                    <td style="font-weight: bold">{{ tran.hash }}
                        <i class="el-icon-document-copy" style="margin-left: 5px;cursor: pointer"
                           v-clipboard:copy="tran.hash"
                           v-clipboard:success="doClipboard"
                           v-clipboard:error=""></i>
                    </td>
                </tr>
                <tr>
                    <td width="190">Status:</td>
                    <td style="padding: 0">
                        <div v-if="tran.status == 1"
                             style="width: 80px;margin: 8px;padding-left: 6px;background: #E5F9F6;color: #3EC6A7"><i
                                class="el-icon-success"></i> Success
                        </div>
                        <div v-if="tran.status == 0"
                             style="width: 80px;margin: 8px;padding-left: 6px;background: #FEF0F0;color: #F56C6C"><i
                                class="el-icon-error"></i> Fail
                        </div>
                    </td>
                </tr>
                <tr>
                    <td width="190">Block:</td>
                    <td>{{ tran.blockNumber }}
                        <span class="u-label--badge-in">{{ block - tran.blockNumber + 1 }} Block Confirmations</span>
                    </td>
                </tr>
                <tr>
                    <td width="190">Timestamp:</td>
                    <td>{{ tran.timestamp | time2Date }}</td>
                </tr>
                <tr>
                    <td width="190">From:</td>
                    <td>
                        <span @click="changeRoute('/transactionList',{addr: tran.from})"
                              class="address">{{ tran.from }}</span>
                        <i class="el-icon-document-copy" style="margin-left: 5px;cursor: pointer"
                           v-clipboard:copy="tran.from"
                           v-clipboard:success="doClipboard"
                           v-clipboard:error=""></i>
                    </td>
                </tr>
                <tr>
                    <td width="190">To:</td>
                    <td>
                        <template v-if="internal.length > 0">Contract</template>
                        <span @click="changeRoute('/transactionList',{addr: tran.to})"
                              class="address">{{ tran.to }}</span>
                        <i v-if="internal.length > 0" class="el-icon-success"
                           style="margin-left: 5px;color: #3EC6A7"></i>
                        <i class="el-icon-document-copy" style="margin-left: 5px;cursor: pointer"
                           v-clipboard:copy="tran.to"
                           v-clipboard:success="doClipboard"
                           v-clipboard:error=""></i>
                        <i @click="internalShow = true"
                           v-show="!internalShow"
                           class="el-icon-circle-plus" style="margin-left: 5px;cursor: pointer"></i>
                        <i @click="internalShow = false"
                           v-show="internalShow"
                           class="el-icon-remove" style="margin-left: 5px;cursor: pointer"></i>
                        <div v-for="tranI in internal" v-if="internalShow || tranI.value > 0"
                             style="height: 30px;line-height: 30px">
                            <img src="@/assets/img/shape-1.svg"
                                 style="width: 7.64px;height: 8px;vertical-align: top;margin-top: 10px;margin-left: 4px">
                            <span style="font-size: 12px;color: #77838f">
                                <span> TRANSFER </span>
                                <span style="color: #1E2022;width: 100px;height: 20px;line-height: 20px;display: inline-block;background-color: rgba(119,131,143,.1);padding: 0 8px"> {{ tranI.value | roundOff(3) }} ETSC</span>
                                <span> From </span>
                                <span @click="changeRoute('/transactionList', {addr: tranI.from})" class="address">
                                    {{ addressSub(tranI.from, 5) }}
                                </span>
                                <span> To </span>
                                <i class="el-icon-right" style="margin-right: 5px"></i>
                                <span @click="changeRoute('/transactionList', {addr: tranI.to})" class="address">
                                    {{ addressSub(tranI.to, 5) }}
                                </span>
                            </span>
                        </div>
                    </td>
                </tr>
                <tr v-if="etsl.length > 0">
                    <td width="190">ETSL:</td>
                    <td>
                        <div v-for="etscI in etsl"
                             style="height: 30px;line-height: 30px">
                            <span style="font-size: 12px;color: #77838f">
                                <span> TRANSFER </span>
                                <span style="color: #1E2022;width: 100px;height: 20px;line-height: 20px;display: inline-block;background-color: rgba(119,131,143,.1);padding: 0 8px"> {{ etscI.value | roundOff(3) }} ETSL</span>
                                <span> From </span>
                                <span @click="changeRoute('/ETSL', {addr: etscI.from})" class="address">
                                    {{ addressSub(etscI.from, 5) }}
                                </span>
                                <span> To </span>
                                <i class="el-icon-right" style="margin-right: 5px"></i>
                                <span @click="changeRoute('/ETSL', {addr: etscI.to})" class="address">
                                    {{ addressSub(etscI.to, 5) }}
                                </span>
                            </span>
                        </div>
                    </td>
                </tr>
                <tr v-if="mpl.length > 0">
                    <td width="190">MPL:</td>
                    <td>
                        <div v-for="mplI in mpl"
                             style="height: 30px;line-height: 30px">
                            <span style="font-size: 12px;color: #77838f">
                                <span> TRANSFER </span>
                                <span style="color: #1E2022;width: 100px;height: 20px;line-height: 20px;display: inline-block;background-color: rgba(119,131,143,.1);padding: 0 8px"> {{ mplI.value | roundOff(3) }} MPL</span>
                                <span> From </span>
                                <span @click="changeRoute('/MPL', {addr: mplI.from})" class="address">
                                    {{ addressSub(mplI.from, 5) }}
                                </span>
                                <span> To </span>
                                <i class="el-icon-right" style="margin-right: 5px"></i>
                                <span @click="changeRoute('/MPL', {addr: mplI.to})" class="address">
                                    {{ addressSub(mplI.to, 5) }}
                                </span>
                            </span>
                        </div>
                    </td>
                </tr>
                <tr v-if="fgc.length > 0">
                    <td width="190">fgc:</td>
                    <td>
                        <div v-for="fgcI in fgc"
                             style="height: 30px;line-height: 30px">
                            <span style="font-size: 12px;color: #77838f">
                                <span> TRANSFER </span>
                                <span style="color: #1E2022;width: 100px;height: 20px;line-height: 20px;display: inline-block;background-color: rgba(119,131,143,.1);padding: 0 8px"> {{ fgcI.value | roundOff(3) }} FGC</span>
                                <span> From </span>
                                <span @click="changeRoute('/FGC', {addr: fgcI.from})" class="address">
                                    {{ addressSub(fgcI.from, 5) }}
                                </span>
                                <span> To </span>
                                <i class="el-icon-right" style="margin-right: 5px"></i>
                                <span @click="changeRoute('/FGC', {addr: fgcI.to})" class="address">
                                    {{ addressSub(fgcI.to, 5) }}
                                </span>
                            </span>
                        </div>
                    </td>
                </tr>

                <tr v-if="fgc3.length > 0">
                  <td width="190">FGC⁺:</td>
                  <td>
                    <div v-for="fgc3I in fgc3"
                         style="height: 30px;line-height: 30px">
                            <span style="font-size: 12px;color: #77838f">
                                <span> TRANSFER </span>
                                <span style="color: #1E2022;width: 100px;height: 20px;line-height: 20px;display: inline-block;background-color: rgba(119,131,143,.1);padding: 0 8px"> {{ fgc3I.value | roundOff(3) }} FGC⁺</span>
                                <span> From </span>
                                <span @click="changeRoute('/FGC3', {addr: fgc3I.from})" class="address">
                                    {{ addressSub(fgc3I.from, 5) }}
                                </span>
                                <span> To </span>
                                <i class="el-icon-right" style="margin-right: 5px"></i>
                                <span @click="changeRoute('/FGC3', {addr: fgc3I.to})" class="address">
                                    {{ addressSub(fgc3I.to, 5) }}
                                </span>
                            </span>
                    </div>
                  </td>
                </tr>

                <tr v-if="nbc3.length > 0">
                  <td width="190">NBC³⁺:</td>
                  <td>
                    <div v-for="nbc3I in nbc3"
                         style="height: 30px;line-height: 30px">
                            <span style="font-size: 12px;color: #77838f">
                                <span> TRANSFER </span>
                                <span style="color: #1E2022;width: 100px;height: 20px;line-height: 20px;display: inline-block;background-color: rgba(119,131,143,.1);padding: 0 8px"> {{ nbc3I.value | roundOff(3) }} NBC³⁺</span>
                                <span> From </span>
                                <span @click="changeRoute('/NBC³⁺', {addr: nbc3I.from})" class="address">
                                    {{ addressSub(nbc3I.from, 5) }}
                                </span>
                                <span> To </span>
                                <i class="el-icon-right" style="margin-right: 5px"></i>
                                <span @click="changeRoute('/NBC³⁺', {addr: nbc3I.to})" class="address">
                                    {{ addressSub(nbc3I.to, 5) }}
                                </span>
                            </span>
                    </div>
                  </td>
                </tr>
                <tr v-if="pps2.length > 0">
                  <td width="190">PPS:</td>
                  <td>
                    <div v-for="pps2I in pps2"
                         style="height: 30px;line-height: 30px">
                            <span style="font-size: 12px;color: #77838f">
                                <span> TRANSFER </span>
                                <span style="color: #1E2022;width: 100px;height: 20px;line-height: 20px;display: inline-block;background-color: rgba(119,131,143,.1);padding: 0 8px"> {{ ppsI.value | roundOff(3) }} pps</span>
                                <span> From </span>
                                <span @click="changeRoute('/PPS2', {addr: pps2I.from})" class="address">
                                    {{ addressSub(pps2I.from, 5) }}
                                </span>
                                <span> To </span>
                                <i class="el-icon-right" style="margin-right: 5px"></i>
                                <span @click="changeRoute('/PPS2', {addr: pps2I.to})" class="address">
                                    {{ addressSub(pps2I.to, 5) }}
                                </span>
                            </span>
                    </div>
                  </td>
                </tr>
                <tr v-if="cmc.length > 0">
                  <td width="190">CMC:</td>
                  <td>
                    <div v-for="cmcI in cmc"
                         style="height: 30px;line-height: 30px">
                            <span style="font-size: 12px;color: #77838f">
                                <span> TRANSFER </span>
                                <span style="color: #1E2022;width: 100px;height: 20px;line-height: 20px;display: inline-block;background-color: rgba(119,131,143,.1);padding: 0 8px"> {{ cmcI.value | roundOff(3) }} CMC</span>
                                <span> From </span>
                                <span @click="changeRoute('/CMC', {addr: cmcI.from})" class="address">
                                    {{ addressSub(cmcI.from, 5) }}
                                </span>
                                <span> To </span>
                                <i class="el-icon-right" style="margin-right: 5px"></i>
                                <span @click="changeRoute('/CMC', {addr: cmcI.to})" class="address">
                                    {{ addressSub(cmcI.to, 5) }}
                                </span>
                            </span>
                    </div>
                  </td>
                </tr>
                <tr v-if="fct.length > 0">
                  <td width="190">FCT:</td>
                  <td>
                    <div v-for="fctI in fct"
                         style="height: 30px;line-height: 30px">
                            <span style="font-size: 12px;color: #77838f">
                                <span> TRANSFER </span>
                                <span style="color: #1E2022;width: 100px;height: 20px;line-height: 20px;display: inline-block;background-color: rgba(119,131,143,.1);padding: 0 8px"> {{ fctI.value | roundOff(3) }} FCT</span>
                                <span> From </span>
                                <span @click="changeRoute('/FCT', {addr: fctI.from})" class="address">
                                    {{ addressSub(fctI.from, 5) }}
                                </span>
                                <span> To </span>
                                <i class="el-icon-right" style="margin-right: 5px"></i>
                                <span @click="changeRoute('/fctI', {addr: fctI.to})" class="address">
                                    {{ addressSub(fctI.to, 5) }}
                                </span>
                            </span>
                    </div>
                  </td>
                </tr>
                <tr v-if="nbc.length > 0">
                  <td width="190">NBC:</td>
                  <td>
                    <div v-for="nbcI in nbc"
                         style="height: 30px;line-height: 30px">
                            <span style="font-size: 12px;color: #77838f">
                                <span> TRANSFER </span>
                                <span style="color: #1E2022;width: 100px;height: 20px;line-height: 20px;display: inline-block;background-color: rgba(119,131,143,.1);padding: 0 8px"> {{ nbcI.value | roundOff(3) }} NBC</span>
                                <span> From </span>
                                <span @click="changeRoute('/NBC', {addr: nbcI.from})" class="address">
                                    {{ addressSub(nbcI.from, 5) }}
                                </span>
                                <span> To </span>
                                <i class="el-icon-right" style="margin-right: 5px"></i>
                                <span @click="changeRoute('/nbcI', {addr: nbcI.to})" class="address">
                                    {{ addressSub(nbcI.to, 5) }}
                                </span>
                            </span>
                    </div>
                  </td>
                </tr>
                <tr v-if="nba.length > 0">
                  <td width="190">NBA:</td>
                  <td>
                    <div v-for="nbaI in nba"
                         style="height: 30px;line-height: 30px">
                            <span style="font-size: 12px;color: #77838f">
                                <span> TRANSFER </span>
                                <span style="color: #1E2022;width: 100px;height: 20px;line-height: 20px;display: inline-block;background-color: rgba(119,131,143,.1);padding: 0 8px"> {{ nbaI.value | roundOff(3) }} NBA</span>
                                <span> From </span>
                                <span @click="changeRoute('/NBC', {addr: nbaI.from})" class="address">
                                    {{ addressSub(nbaI.from, 5) }}
                                </span>
                                <span> To </span>
                                <i class="el-icon-right" style="margin-right: 5px"></i>
                                <span @click="changeRoute('/nbcI', {addr: nbaI.to})" class="address">
                                    {{ addressSub(nbaI.to, 5) }}
                                </span>
                            </span>
                    </div>
                  </td>
                </tr>
                <tr v-if="nba.length > 0">
                  <td width="190">NBC³:</td>
                  <td>
                    <div v-for="nbbI in nbb"
                         style="height: 30px;line-height: 30px">
                            <span style="font-size: 12px;color: #77838f">
                                <span> TRANSFER </span>
                                <span style="color: #1E2022;width: 100px;height: 20px;line-height: 20px;display: inline-block;background-color: rgba(119,131,143,.1);padding: 0 8px"> {{ nbbI.value | roundOff(3) }} NBC³</span>
                                <span> From </span>
                                <span @click="changeRoute('/NBC', {addr: nbbI.from})" class="address">
                                    {{ addressSub(nbbI.from, 5) }}
                                </span>
                                <span> To </span>
                                <i class="el-icon-right" style="margin-right: 5px"></i>
                                <span @click="changeRoute('/nbcI', {addr: nbbI.to})" class="address">
                                    {{ addressSub(nbbI.to, 5) }}
                                </span>
                            </span>
                    </div>
                  </td>
                </tr>
                <tr v-if="ethc.length > 0">
                    <td width="190">ETHC:</td>
                    <td>
                        <div v-for="e in ethc"
                             style="height: 30px;line-height: 30px">
                            <span style="font-size: 12px;color: #77838f">
                                <span> TRANSFER </span>
                                <span style="color: #1E2022;width: 100px;height: 20px;line-height: 20px;display: inline-block;background-color: rgba(119,131,143,.1);padding: 0 8px"> {{ e.value | roundOff(5) }} ETHC</span>
                                <span> From </span>
                                <span @click="changeRoute('/ETHC', {addr: e.from})" class="address">
                                    {{ addressSub(e.from, 5) }}
                                </span>
                                <span> To </span>
                                <i class="el-icon-right" style="margin-right: 5px"></i>
                                <span @click="changeRoute('/ETHC', {addr: e.to})" class="address">
                                    {{ addressSub(e.to, 5) }}
                                </span>
                            </span>
                        </div>
                    </td>
                </tr>
                <tr v-if="eusd.length > 0">
                    <td width="190">EUSD:</td>
                    <td>
                        <div v-for="e in eusd"
                             style="height: 30px;line-height: 30px">
                            <span style="font-size: 12px;color: #77838f">
                                <span> TRANSFER </span>
                                <span style="color: #1E2022;width: 100px;height: 20px;line-height: 20px;display: inline-block;background-color: rgba(119,131,143,.1);padding: 0 8px"> {{ e.value }} EUSD</span>
                                <span> From </span>
                                <span @click="changeRoute('/EUSD', {addr: e.from})" class="address">
                                    {{ addressSub(e.from, 5) }}
                                </span>
                                <span> To </span>
                                <i class="el-icon-right" style="margin-right: 5px"></i>
                                <span @click="changeRoute('/EUSD', {addr: e.to})" class="address">
                                    {{ addressSub(e.to, 5) }}
                                </span>
                            </span>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td width="190">Value:</td>
                    <td><span
                            style="background-color: rgba(119,131,143,.1);padding: 5px 8px">{{ tran.value }} ETSC</span>
                    </td>
                </tr>
                <tr>
                    <td width="190">Gas Price:</td>
                    <td>{{ tran.gasPrice / 1e9}} gwei</td>
                </tr>
                <tr>
                    <td width="190">Gas Limit:</td>
                    <td>{{ tran.gasLimit | fmoney }}</td>
                </tr>
                <tr>
                    <td width="190">Gas Used:
                    </td>
                    <td>{{ tran.gasUsed | fmoney }}</td>
                </tr>
                <tr>
                    <td width="190">Nonce:</td>
                    <td>{{ tran.nonce }}</td>
                </tr>
                <tr>
                    <td width="190">
                        Extra Data:
                    </td>
                    <td>{{ tran.extraData }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <LoadingV style="bottom: 50%;transform: translateY(-50%)"></LoadingV>
    </div>
</template>

<script>
    import axios from 'axios';
    import {getBlockNumber} from '@/assets/js/etherjs/web3';
    import {ethers} from "ethers"
    import Config from '@/assets/js/config/load';
    const config = Config();

    export default {
        name: "blocksDetail",
        data() {
            return {
                tran: {},
                internal: [],
                block: 0,
                internalShow: false,
                etsl:[],
                mpl:[],
                pps: [],
                pps2: [],
                cmc: [],
                fct: [],
                ethc:[],
                eusd: [],
                nbc: [],
                nba: [],
                nbb: [],
                fgc: [],
                nbc3: [],
                fgc3: [],
            }
        },
        mounted() {
            this.init();
        },
        watch: {
            '$route'(to, from) {
                if (to.name == from.name) {
                    this.init();
                }
            }
        },
        methods: {
            async init() {
                this.getTransaction();
                this.getTransactionInternal();
                this.getERC20();
                this.block = await getBlockNumber();
            },
            //投注
            getTransaction() {
                this.tran = {};
                this.aLoadingV({show: true});
                return axios.get(this.requestConfig.apiHost + '/client/explore/transaction', {
                    params: {
                        hash: this.$route.query.hash,
                        type: "detail"
                    }
                }).then((response) => {
                    this.aLoadingV({show: false});
                    if (response.data.error_code != 0) {
                        throw new Error("get list error");
                    }
                    this.tran = response.data.data[0];
                }).catch((error) => {
                    this.aLoadingV({show: false});
                    console.log(error);
                });
            },
            getTransactionInternal() {
                this.tran = {};
                this.aLoadingV({show: true});
                return axios.get(this.requestConfig.apiHost + '/client/explore/transaction/internal', {
                    params: {
                        hash: this.$route.query.hash,
                        pageNo: 1,
                        pageSize: 100
                    }
                }).then((response) => {
                    this.aLoadingV({show: false});
                    if (response.data.error_code != 0) {
                        throw new Error("get list error");
                    }
                    this.internal = response.data.data;
                }).catch((error) => {
                    this.aLoadingV({show: false});
                    console.log(error);
                });
            },

            getERC20() {
                this.mpl = [];
                this.aLoadingV({show: true});
                return axios.get(this.requestConfig.apiHost + '/client/explore/erc20', {
                    params: {
                        txHash: this.$route.query.hash,
                    }
                }).then((response) => {
                    let res = response.data.data;
                    if (res.length > 0) {
                        for (let i in res) {
                            if(res[i].contractAddress == "0x5D50cb9b023FB2236371fda99dDcddFb6F49b4e0") {
                                res[i].value = parseFloat(ethers.utils.formatEther(res[i].value));
                                this.mpl.push(res[i]);
                            }
                            if(res[i].contractAddress == "0x6e7fE95BFCea127fAE98C517387740C99B4aDb04") {
                                res[i].value = parseFloat(ethers.utils.formatEther(res[i].value));
                                this.ethc.push(res[i]);
                            }
                            if(res[i].contractAddress == "0x23D58a59226Ba286E3AeB83D4576D75ffD099077") {
                                res[i].value = parseFloat(ethers.utils.formatEther(res[i].value));
                                this.etsl.push(res[i]);
                            }
                            if(res[i].contractAddress == "0xCB43D0405CAEF8Fe69D3E5fb27A7412F87FaA17D") {
                                res[i].value = parseFloat(ethers.utils.formatEther(res[i].value));
                                this.fgc.push(res[i]);
                            }
                            if(res[i].contractAddress == config.PPS.addrss) {
                                res[i].value = parseFloat(ethers.utils.formatEther(res[i].value));
                                this.pps2.push(res[i]);
                            }
                            if(res[i].contractAddress == "0xFEe36609483D7391e4399A5F427c6785d3c44039") {
                                res[i].value = parseFloat(ethers.utils.formatUnits(res[i].value, 6));
                                this.eusd.push(res[i]);
                            }
                            if(res[i].contractAddress == "0x405023aE85e91644935510c3685dE38631911660") {
                              res[i].value = parseFloat(ethers.utils.formatUnits(res[i].value, 6));
                              this.cmc.push(res[i]);
                            }
                          if(res[i].contractAddress == "0x40611C80C5FA27fd2FF03510F083a84d3402E523") {
                            res[i].value = parseFloat(ethers.utils.formatUnits(res[i].value, 6));
                            this.fct.push(res[i]);
                          }
                          if(res[i].contractAddress == "0xF247921c9b15E7a66314fA55F89FaCa440d8439C") {
                            res[i].value = parseFloat(ethers.utils.formatUnits(res[i].value, 6));
                            this.nbc.push(res[i]);
                          }
                          if(res[i].contractAddress == "0x650d13D2F9aA167b8CB6B3270f50CEB31F73c90D") {
                            res[i].value = parseFloat(ethers.utils.formatUnits(res[i].value, 6));
                            this.nba.push(res[i]);
                          }
                          if(res[i].contractAddress == "0x09274B66BF14948ac13721A564C1e974BcaF61c6") {
                            res[i].value = parseFloat(ethers.utils.formatUnits(res[i].value, 6));
                            this.nbb.push(res[i]);
                          }
                          if(res[i].contractAddress == "0xd8b2823b3FA9e6Fe109fdf9b6a7A296e4D0a30Bd") {
                            res[i].value = parseFloat(ethers.utils.formatUnits(res[i].value, 6));
                            this.nbc3.push(res[i]);
                          }
                        }
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },

            doClipboard: function () {
                this.$message({
                    message: '复制成功',
                    type: 'success'
                });
            },
        }
    }
</script>

<style scoped>
    .main {
        width: 1200px;
        margin: 0 auto;
    }

    table {
        padding: 10px 5px;
    }

    table td {
        padding: 8px;
        line-height: 1.42857143;
        vertical-align: top;
        font-size: 13px;
    }

    table tr td a {
        color: #3498db;
        text-decoration: none;
    }

    table tr td a:hover {
        text-decoration: underline;
        text-decoration-color: #3498db;
    }

    .address {
        color: #3498db;
        cursor: pointer;
    }

    .address:hover {
        color: #1d6fa5;
    }

    .u-label--badge-in {
        padding: 3.6px 8px;
        position: relative;
        padding-left: 18.4px;
        letter-spacing: 0.8px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        color: #77838f;
        background-color: rgba(119, 131, 143, .1);
        display: inline-block;
    }

    .u-label--badge-in:after {
        position: absolute;
        left: 0;
        top: 0;
        content: "";
        border-top: 11.2px solid transparent;
        border-bottom: 11.2px solid transparent;
        border-left: 11.2px solid #fff;
    }
</style>
